import React from "react";
import { Box, Typography, Card, CardContent, Button, Grid, Container } from "@mui/material";
import { FadeLoader } from "react-spinners";

const OrderSummary = ({
    setActiveStep,
    handleBack,
    formData,
    selectedTicket,
    setSelectedTicket,
    ticketOptions,
    paymentMethods,
    selectedPayment,
    setSelectedPayment,
}) => {

    const subtotal = selectedTicket?.price || 0;
    const convenienceFee = 5;
    const total = subtotal + convenienceFee;

    return (
        <>
            <Container maxWidth="md">

                <Box>
                    {/* Participant Summary */}
                    {/* <Typography sx={{ fontWeight: "bold" }} variant="h6" gutterBottom>
                        My Info
                    </Typography> */}
                    {/* <Box mb={3} p={2} sx={{ opacity: .5, border: "1px solid #ddd", borderRadius: 2 }}>
                        <Typography>
                            {formData?.name} {formData?.lastName}
                        </Typography>
                        <Typography>{formData?.email}</Typography>
                        <Typography>{formData?.mobileNumber}</Typography>
                    </Box> */}

                    {/* Ticket Type Selection */}
                    <Typography sx={{ fontWeight: "bold" }} variant="h6" gutterBottom>
                        Select Ticket
                    </Typography>
                    <Grid container spacing={2}>
                        {ticketOptions.length > 0 ? (
                            <>
                                {ticketOptions.map((ticket) => {
                                    // Determine which price to use
                                    const today = new Date();
                                    const earlyBirdDate = ticket.earlyBirdDate ? new Date(ticket.earlyBirdDate) : null;
                                    const isEarlyBirdActive = earlyBirdDate && today < earlyBirdDate;
                                    const finalPrice = isEarlyBirdActive && ticket.earlyBirdPrice ? ticket.earlyBirdPrice : ticket.price;

                                    return (
                                        <Grid item xs={12} key={ticket._id}>
                                            <Card
                                                sx={{
                                                    padding: 1,
                                                    borderRadius: 2,
                                                    cursor: "pointer",
                                                    backgroundColor: selectedTicket?._id !== ticket._id ? "#fff" : "#f8f9fa",
                                                    border: selectedTicket?._id === ticket._id ? "2px solid black" : "2px solid transparent",
                                                    boxShadow: selectedTicket?._id === ticket._id ? "0px 5px 30px rgba(0, 0, 0, 0.1)" : "0px 5px 30px rgba(0, 0, 0, 0.1)",
                                                    transition: "all 0.3s ease-in-out",
                                                    transform: selectedTicket?._id === ticket._id ? "scale(1.02)" : "scale(1)", // Subtle scale effect on selection
                                                }}
                                                onClick={() => setSelectedTicket(ticket)}
                                            >
                                                <CardContent sx={{ display: "flex", flexDirection: "column" }}>
                                                    {/* First Row: Title & Price */}
                                                    <Box display="flex" justifyContent="space-between" alignItems="center">
                                                        <Typography variant="h6" >
                                                            {ticket.title}
                                                        </Typography>
                                                        <Typography variant="h6" sx={{ fontWeight: "bold", color: "textSecondary" }}>
                                                            ₱{finalPrice.toLocaleString()}
                                                        </Typography>
                                                    </Box>

                                                    {/* Second Row: Slots Left */}
                                                    <Typography variant="body2" color="textSecondary">
                                                        ({ticket.slots} Slots Left)
                                                    </Typography>

                                                    {/* Third Row: Early Bird Indicator */}
                                                    {isEarlyBirdActive && ticket.earlyBirdPrice && (
                                                        <Typography variant="body2" color="green">
                                                            Early Bird Price Active Until {new Date(ticket.earlyBirdDate).toLocaleDateString()}
                                                        </Typography>
                                                    )}

                                                    {/* Fourth Row: Description */}
                                                    <Typography variant="body2" color="textSecondary" mt={1}>
                                                        {ticket.description}
                                                    </Typography>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    );
                                })}
                            </>
                        ) : (
                            <Grid item xs={12} sx={{ width: "100%", height: 200, display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <FadeLoader color="black" loading={true} size={50} />
                            </Grid>
                        )}
                    </Grid>


                    {/* Mode of Payment */}
                    <Typography sx={{ fontWeight: "bold" }} variant="h6" gutterBottom mt={3}>
                        Select Payment
                    </Typography>
                    <Grid container spacing={2}>
                        {paymentMethods.length > 0 ?
                            <>
                                {paymentMethods.map((method) => (
                                    <Grid item xs={6} key={method._id}>
                                        <Card
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                // justifyContent: "center", // Center everything inside the card
                                                padding: 2,
                                                borderRadius: 2,
                                                cursor: "pointer",
                                                border: selectedPayment?._id === method._id ? "2px solid black" : "2px solid transparent",
                                                boxShadow: selectedPayment?._id === method._id ? "0px 5px 30px rgba(0, 0, 0, 0.1)" : "0px 0px 30px rgba(0, 0, 0, 0.1)",
                                                backgroundColor: selectedPayment?._id !== method._id ? "#fff" : "#f8f9fa",
                                                transition: "all 0.3s ease-in-out",
                                                transform: selectedPayment?._id === method._id ? "scale(1.02)" : "scale(1)", // Subtle scale effect on selection

                                                // height: 70, // Ensure consistent height
                                            }}
                                            onClick={() => setSelectedPayment(method)}
                                        >
                                            <img
                                                src={method.icon}
                                                alt={method.title}
                                                style={{ width: 35, height: 35, marginRight: 10 }}
                                            />
                                            <Typography variant="body1">{method.title}</Typography>
                                        </Card>
                                    </Grid>
                                ))}
                            </>
                            :
                            <Grid item xs={12} sx={{ width: "100%", height: 200, display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <FadeLoader color="black" loading={true} size={50} />
                            </Grid>
                        }
                    </Grid>

                    {/* Terms and Conditions */}
                    <Box mt={5} mb={10} sx={{ opacity: .5 }}>
                        <Typography mb={1} variant="body2">Terms and Conditions</Typography>
                        <Typography variant="body2" color="textSecondary">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                            Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                        </Typography>
                    </Box>

                </Box>
            </Container>
            {/* Summary & Navigation */}
            <Box
                sx={{
                    // width: "100%",
                    position: "sticky",
                    bottom: 0,
                    backgroundColor: "white",
                    boxShadow: "0px -2px 10px rgba(0, 0, 0, 0.1)",
                    padding: "16px",
                    zIndex: 1000,
                }}
            >
                <Container maxWidth="md" >

                    <Box display="flex" justifyContent="space-between" mb={1}>
                        <Typography variant="body2" color="textSecondary">
                            Convenience Fee
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            ₱{convenienceFee.toFixed(2)}
                        </Typography>
                    </Box>

                    <Box display="flex" justifyContent="space-between" mb={2}>
                        <Typography variant="h6" fontWeight="bold">
                            Total
                        </Typography>
                        <Typography variant="h6" fontWeight="bold">
                            ₱{total.toFixed(2)}
                        </Typography>
                    </Box>

                    {/* Buttons */}
                    <Box display="flex" justifyContent="space-between">
                        <Button
                            fullWidth
                            variant="contained"
                            type="submit"
                            sx={{
                                borderRadius: "50px",
                                bgcolor: "#1976d2", color: "white"
                            }}

                            onClick={() => setActiveStep(2)}
                            disabled={!selectedTicket || !selectedPayment}

                        >
                            Next
                        </Button>
                    </Box>
                </Container>
            </Box>
        </>
    );
};

export default OrderSummary;
